type RouteObject = {
  [key: string]: string | RouteObject
}

type RouteEntity = string | RouteObject
export const ROUTES = {
  website: {
    index: "",
    home: "home",
    aoi: "aoi",
    wayleave: "wayleave",
    industries: "industries",
    ourServices: "our-services",
    quote: "free-quote",
    privacyPolicy: "privacy-policy",
    preparingGeometry: "preparing-geometry",
    termsAndConditions: "terms-and-conditions",
    auth: "auth",
    notFound: "not-found",
    emailConfirmed: "email-confirmed",
    emailNotConfirmed: "email-not-confirmed",
    emailConfirmation: "auth/email-confirmation",
    forgotPasswordConfirmation: "auth/forgot-password-confirmation",
    blog: "blog",
    consulting: "consulting",
    channelPartners: "one-submission",
    thankYouPage: "thank-you",
    software: "software",
  },
  dashboard: {
    index: "dashboard",
    overview: "overview",
    emails: "emails",
    projects: "projects",
    applications: "applications",
    application: "application",
    aoi: "aoi",
    aois: "aoi-applications",
    companies: "companies",
    company: "company",
    customers: "customers",
    employees: "employees",
    users: "users",
    agentProfessionalsTasks: "agents-professionals/tasks",
    tasks: "tasks",
    task: "task",
    project: "project",
    projectApplications: "project-applications",
    projectTasks: "project-tasks",
    applicationReports: "application-reports",
    reports: "reports",
    serviceProviderApplications: "service-provider/applications",
    governmentWorks: "government-works",
    profile: "profile",
    templateGroups: "template-groups",
    templateSubject: "template-subject",
    templateSubjects: "template-subjects",
    templateDocument: "template-document",
    managerMap: "manager-map",
    createProject: "create-project",
    createTask: "create-task",
    createNote: "create-note",
    createAoi: "create-aoi",
    platformSettings: "platform-settings",
    emailLogs: "email-logs",
    quoteRequests: "quote-requests",
    companyUpdateRequests: "company-update-requests",
    enforcements: "enforcements",
    enforcement: "enforcement",
    assistanceRequests: "assistance-requests",
    licenseUpdateRequests: "license-update-requests",
    mapGeometry: "map-geometry",
    settings: "settings",
    surveys: "surveys",
  },
}

const mapRoutesToParent = (route: RouteEntity, parentPath: string): RouteEntity => {
  return Object.entries(route).reduce((acc, [key, value]) => {
    const routePath = `${parentPath}${key === "index" || parentPath === "/" ? "" : "/"}`

    if (typeof value === "string") {
      return {
        ...acc,
        [key]: `${routePath}${key === "index" ? "" : value}`,
      }
    }

    return {
      ...acc,
      [key]: mapRoutesToParent(value, `${routePath}${value.index}`),
    }
  }, {})
}

export const websiteRoutes = mapRoutesToParent(ROUTES, "/") as typeof ROUTES

/**
 * The wayleave guides: static pages built from Markdown (src/utilities/guidesPlugin.ts) and served by the CMS, not
 * routes of this app. Link to them with a plain <a href> (a full page load, and a link search engines follow), never
 * navigate().
 */
export const WAYLEAVE_GUIDE_PATH = "/wayleave-guide"
